import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import globals from "../../globals";
import Icon from "../Icon";
import { useDispatch, useSelector } from "react-redux";

function Sidebar() {
  const sidebarRef = useRef(null);
  const layoutMenuRef = useRef(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  // const userDetails = useSelector((state) => state.admininfo.admininfo.role.name);
  // console.log("sidebardata",userDetails)
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 1200);
    };
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    layoutMenuRef.current = document.querySelector(".layout-menu");
  }, []);

  const togglemobileMenu = () => {
    const htmlElement = document.documentElement;

    htmlElement.classList.remove("layout-menu-expanded");
  };

  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  useEffect(() => {
    if (isMobileView) {
      const handleClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
          togglemobileMenu(); // Close the sidebar
        }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isMobileView, togglemobileMenu]);
  console.log(globals);
  const hasPermission = (name) => {
    return userDetails.some((role) => role.name === name && role.view === "true");
  };
  
  return (
    <>
      <aside
        id="layout-menu"
        className={`layout-menu menu-vertical menu bg-menu-theme`}
        ref={sidebarRef}
      >
        <div className="app-brand demo">
          <a
            href="/dashboard"
            className="app-brand-link"
            style={{ height: "100%" }}
          >
            <img
              src="/images/logo.png"
              alt="Invitd"
              style={{ height: "100%" }}
            />
          </a>
        </div>
        <div className="menu-inner-shadow"></div>
        <ul className="menu-inner py-3">
        <NavLink
  to="/dashboard"
  className={({ isActive }) =>
    `menu-item ${isActive ? "active open" : ""}`
  }
>
  <span className="menu-link" onClick={togglemobileMenu}>
    <Icon name={globals?.dashboard?.icon || ""} size={18} className="me-2" />
    <div>{globals?.dashboard?.title || "Dashboard"}</div>
  </span>
</NavLink>
{/* {hasPermission("package") && ( */}
  {/* <NavLink to="/Package" className={({ isActive }) => `menu-item ${isActive ? "active open" : ""}`}>
    <span className="menu-link" onClick={togglemobileMenu}>
      <Icon name={globals?.Package?.icon || ""} size={18} className="me-2" />
      <div>{globals?.Package?.title || "User Package"}</div>
    </span>
  </NavLink> */}
{/* )} */}
{/* {hasPermission("CreateUser") && ( */}
 {/* <NavLink
 to="/CreateUser"
 className={({ isActive }) =>
   `menu-item ${isActive ? "active open" : ""}`
 }
>
 <span className="menu-link" onClick={togglemobileMenu}>
   <Icon
     name={globals?.admin?.icon || ""}
     size={18}
     className="me-2"
   />
   <div>{globals?.admin?.title || "Create User"}</div>
 </span>
</NavLink> */}
{/* )} */}

{/* {hasPermission("Reports") && ( */}
  {/* <NavLink
  to="/Reports"
  className={({ isActive }) =>
    `menu-item ${isActive ? "active open" : ""}`
  }
>
  <span className="menu-link" onClick={togglemobileMenu}>
    <Icon
      name={globals?.Reports?.icon || ""}
      size={18}
      className="me-2"
    />
    <div>{globals?.Reports?.title || "Reports"}</div>
  </span>
</NavLink> */}
{/* )} */}
{/* {hasPermission("Customer") && ( */}
  {/* <NavLink
  to="/Customer"
  className={({ isActive }) =>
    `menu-item ${isActive ? "active open" : ""}`
  }
>
  <span className="menu-link" onClick={togglemobileMenu}>
    <Icon
      name={globals?.Customer?.icon || ""}
      size={18}
      className="me-2"
    />
    <div>{globals?.Customer?.title || "Customer"}</div>
  </span>
</NavLink> */}
{/* )} */}
{/* {hasPermission("rool") && ( */}
 {/* <NavLink
 to="/Roll"
 className={({ isActive }) =>
   `menu-item ${isActive ? "active open" : ""}`
 }
>
 <span className="menu-link" onClick={togglemobileMenu}>
   <Icon
     name={globals?.Roll?.icon || ""}
     size={18}
     className="me-2"
   />
   <div>{globals?.Roll?.title || "User Roll"}</div>
 </span>
</NavLink> */}
{/* )} */}
{/* {hasPermission("Application") && ( */}
  {/* <NavLink
  to="/Application"
  className={({ isActive }) =>
    `menu-item  ${isActive ? "active open" : ""}  `
  }
>
  <span className="menu-link" onClick={togglemobileMenu}>
    <Icon
      name={globals.Application.icon}
      size={18}
      className="me-2"
    />
    <div>{globals.Application.title}</div>
  </span>
</NavLink> */}
{/* )} */}
{/* {hasPermission("Application") && ( */}
 
 {/* <NavLink
 to="/TestRegister"
 className={({ isActive }) =>
   `menu-item  ${isActive ? "active open" : ""}  `
 }
>
 <span className="menu-link" onClick={togglemobileMenu}>
   <Icon
     name={globals.TestRegister.icon}
     size={18}
     className="me-2"
   />
   <div>{globals.TestRegister.title}</div>
 </span>
</NavLink> */}
{/* )} */}

        </ul>
      </aside>
      {/* <!-- Overlay --> */}
      <div className="layout-overlay layout-menu-toggle"></div>

      {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
      <div className="drag-target"></div>
    </>
  );
}

export default Sidebar;
